import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vShow as _vShow, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a0d80e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid h-100 flex-fill flex-column d-flex" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 p-0 position-relative" }
const _hoisted_4 = { class: "entity-code-input" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text rounded-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" })
], -1))
const _hoisted_7 = ["disabled", "value", "placeholder"]
const _hoisted_8 = {
  key: 0,
  id: "entity-codes"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "row h-100" }
const _hoisted_12 = { class: "col-12 p-0 h-100 position-relative" }
const _hoisted_13 = { class: "map-container h-100" }
const _hoisted_14 = {
  class: "map-legend position-absolute top-0 start-0 bg-white",
  style: {"z-index":"1","max-width":"200px"}
}
const _hoisted_15 = { class: "list-group" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = ["disabled", "value", "id"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  class: "d-none d-sm-block ms-1",
  style: {"text-transform":"uppercase"}
}
const _hoisted_20 = { class: "form-check form-check-inline custom-margin pe-0 me-0" }
const _hoisted_21 = ["disabled", "value"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "h-100 w-100"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_Transition, { name: "shake" }, {
              default: _withCtx(() => [
                _createElementVNode("input", {
                  list: "entity-codes",
                  disabled: _ctx.renderComponent,
                  value: _ctx.entityCode,
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.entityCode = $event.target.value)),
                  class: _normalizeClass({'is-invalid': _ctx.error, 'form-control shake': _ctx.error, 'form-control': !_ctx.error}),
                  placeholder: _ctx.$t.enterEntityCode,
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomToEntity && _ctx.zoomToEntity(...args)))
                }, null, 42, _hoisted_7)
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zoomToEntity && _ctx.zoomToEntity(...args)))
            }, _toDisplayString(_ctx.$t.search), 1),
            (_ctx.entityCode.length >= 2 && !_ctx.renderComponent)
              ? (_openBlock(), _createElementBlock("datalist", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities.features, (feature) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: feature.properties.code,
                      key: feature.properties.code
                    }, null, 8, _hoisted_9))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t.entityNotFound), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconTypes, (iconType) => {
                return (_openBlock(), _createElementBlock("label", {
                  class: "list-group-item rounded-0 d-flex align-items-center",
                  key: iconType
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: _ctx.renderComponent,
                      class: "form-check-input me-2 checkbox-lg",
                      type: "checkbox",
                      value: iconType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedIconTypes) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateSymbolVisibility && _ctx.updateSymbolVisibility(...args))),
                      id: iconType,
                      checked: ""
                    }, null, 40, _hoisted_17), [
                      [_vModelCheckbox, _ctx.checkedIconTypes]
                    ]),
                    _createElementVNode("img", {
                      class: "mt-1",
                      src: _ctx.getIconPath(iconType),
                      alt: iconType,
                      style: {"height":"24px","width":"24px"}
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.iconTypesLabels[iconType]), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeZoomOnSelectClusterIcon && _ctx.changeZoomOnSelectClusterIcon(...args))),
                      disabled: _ctx.renderComponent,
                      class: "form-check-input",
                      type: "radio",
                      name: "clusterIconType",
                      value: iconType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.selectedClusterIconType) = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clusterIconChanged()))
                    }, null, 40, _hoisted_21), [
                      [_vModelRadio, this.selectedClusterIconType]
                    ])
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.showLegend]
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary w-100 rounded-0 toggle-legend animate__animated animate__fadeIn",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleLegend && _ctx.toggleLegend(...args)))
            }, _toDisplayString(_ctx.$t.toggleLegend), 1)
          ]),
          _createVNode(_component_Loading, {
            active: _ctx.renderComponent,
            "onUpdate:active": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.renderComponent) = $event)),
            "can-cancel": false,
            "is-full-page": false,
            style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
          }, null, 8, ["active"]),
          _hoisted_22
        ])
      ])
    ])
  ]))
}